// Author Liang Gangqiang
// Date 2023-07-27 09:51:21

class SithMesQualityInspectTask {
    constructor({
                    id = null,
                    code = '',
                    inspectTypeId = '',
                    project = '',
                    inspectObject = '',
                    faufCode = '',
                    blueprintCode = '',
                    groupCode = '',
                    material = '',
                    startTime = '',
                    inspectTime = '',
                    inspector = '',
                    attestation = '',
                    qualified = '',
                    ncrCode = '',
                    remark = '',
                    taskAttachment = '',
                    taskAttachmentList = ''
                }
                    = {}) {
        this.id = id;
        this.code = code;
        this.inspectTypeId = inspectTypeId;
        this.project = project;
        this.inspectObject = inspectObject;
        this.faufCode = faufCode;
        this.blueprintCode = blueprintCode;
        this.groupCode = groupCode;
        this.material = material;
        this.startTime = startTime;
        this.inspectTime = inspectTime;
        this.inspector = inspector;
        this.attestation = attestation;
        this.qualified = qualified;
        this.ncrCode = ncrCode;
        this.remark = remark;
        this.taskAttachment = taskAttachment;
        this.taskAttachmentList = taskAttachmentList;
    }
}

function newEntity() {
    return new SithMesQualityInspectTask();
}

const incomingVoConfigs = [
    {
        key: 'code',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.code',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTypeName',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.inspectTypeName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'project',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.project',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.remark',
        sortable: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByName',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.createdByName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supplier',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.supplier',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'contractCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.contractCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine1',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.projectMachine1',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'batchCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.batchCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItem',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.poItem',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.materialCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescription',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.materialDescription',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'faufCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.faufCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'blueprintCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.blueprintCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'groupCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.groupCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'material',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.material',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTime',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.startTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTime',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.inspectTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspector',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.inspector',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attestation',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.attestation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qualified',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.qualified',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncrProcessCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.ncrProcessCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'taskAttachmentList',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.taskAttachmentList',
        sortable: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    }
]
const processVoConfigs = [
    {
        key: 'code',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.code',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTypeName',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.inspectTypeName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'project',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.project',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.remark',
        sortable: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByName',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.createdByName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'contractCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.contractCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine1',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.projectMachine1',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.orderCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationSeq',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.operationSeq',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bufferHour',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.bufferHour',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mstWorkCenterName',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.mstWorkCenterName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mstLocationName',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.mstLocationName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.materialCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescription',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.materialDescription',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'faufCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.faufCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'blueprintCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.blueprintCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'groupCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.groupCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'material',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.material',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTime',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.startTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTime',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.inspectTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspector',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.inspector',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attestation',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.attestation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qualified',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.qualified',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncrProcessCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.ncrProcessCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'taskAttachmentList',
        label: 'label.sith.quality.sithMesQualityInspectTask.grid.taskAttachmentList',
        sortable: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    }
]
const sithMesQualityInspectTaskEndVoConfigs = [
    {
        key: 'code',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.code',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTypeName',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.inspectTypeName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'project',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.project',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.remark',
        sortable: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByName',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.createdByName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryNo',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.deliveryNo',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionStation',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.inspectionStation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionInitiatorName',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.inspectionInitiatorName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'faufCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.faufCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'blueprintCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.blueprintCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'groupCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.groupCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'material',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.material',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTime',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.startTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTime',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.inspectTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspector',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.inspector',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attestation',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.attestation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qualified',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.qualified',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncrProcessCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.ncrProcessCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'taskAttachmentList',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.grid.taskAttachmentList',
        sortable: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    }
]
const sithMesQualityInspectTaskIncomingVoConfigs = [
    {
        key: 'code',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.code',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationManager',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.operationManager',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectManager',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.projectManager',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'engineer',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.engineer',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTypeName',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.inspectTypeName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'project',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.project',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.remark',
        sortable: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.materialCode',
        sortable: true,
        form: {
            type: 'input',
            linkTo: 'material_bom',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialName',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.materialName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packingMaterial',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.packingMaterial',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendor',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.vendor',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNumber',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.vendorNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchaser',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.purchaser',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectQuantity',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.inspectQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poNumber',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.poNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.itemCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'credential',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.credential',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'locName',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.locName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByName',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.createdByName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'faufCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.faufCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'blueprintCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.blueprintCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'groupCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.groupCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'material',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.material',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTime',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.startTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTime',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.inspectTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspector',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.inspector',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attestation',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.attestation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qualified',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.qualified',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncrProcessCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.ncrProcessCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sdrCreator',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.sdrCreator',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'taskAttachmentList',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.grid.taskAttachmentList',
        sortable: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    }
]
const sithMesQualityInspectTaskReturnStockVoConfigs = [
    {
        key: 'code',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.code',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTypeName',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.inspectTypeName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'project',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.project',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.remark',
        sortable: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.orderCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.materialCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescription',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.materialDescription',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnQuantity',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.returnQuantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialLocation',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.materialLocation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByName',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.createdByName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'faufCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.faufCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'blueprintCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.blueprintCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'groupCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.groupCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'material',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.material',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTime',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.startTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTime',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.inspectTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspector',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.inspector',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attestation',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.attestation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qualified',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.qualified',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncrProcessCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.ncrProcessCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'taskAttachmentList',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.grid.taskAttachmentList',
        sortable: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    }
]
const sithMesQualityInspectTaskOutsourceVoConfigs = [
    {
        key: 'code',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.grid.code',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectName',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.grid.projectName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTypeName',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.grid.inspectTypeName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'project',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.grid.project',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.grid.remark',
        sortable: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByName',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.grid.createdByName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'faufCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.grid.faufCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'blueprintCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.grid.blueprintCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'groupCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.grid.groupCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'material',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.grid.material',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTime',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.grid.startTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTime',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.grid.inspectTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspector',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.grid.inspector',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attestation',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.grid.attestation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qualified',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.grid.qualified',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncrProcessCode',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.grid.ncrProcessCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'taskAttachmentList',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.grid.taskAttachmentList',
        sortable: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    }
]

function gridFields() {
    return Object.freeze([
        {
            key: 'code',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.code',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inspectTypeName',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.inspectTypeName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'project',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.project',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.remark',
            sortable: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdByName',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.createdByName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'supplier',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.supplier',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'contractCode',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.contractCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectMachine1',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.projectMachine1',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'batchCode',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.batchCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poItem',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.poItem',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderCode',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.orderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operationSeq',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.operationSeq',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bufferHour',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.bufferHour',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mstWorkCenterName',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.mstWorkCenterName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mstLocationName',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.mstLocationName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialCode',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.materialCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialDescription',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.materialDescription',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'faufCode',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.faufCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'blueprintCode',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.blueprintCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'groupCode',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.groupCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'material',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.material',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'startTime',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.startTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inspectTime',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.inspectTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inspector',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.inspector',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'attestation',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.attestation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'qualified',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.qualified',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ncrProcessCode',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.ncrProcessCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'taskAttachmentList',
            label: 'label.sith.quality.sithMesQualityInspectTask.grid.taskAttachmentList',
            sortable: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    codeFilter: '',
    inspectTypeIdFilter: '',
    projectFilter: '',
    supplierFilter: '',
    contractCodeFilter: '',
    projectCodeFilter: '',
    projectNameFilter: '',
    projectMachine1Filter: '',
    batchCodeFilter: '',
    inspectObjectFilter: '',
    createdByNameFilter: '',
    orderCodeFilter: '',
    faufCodeFilter: '',
    blueprintCodeFilter: '',
    groupCodeFilter: '',
    materialFilter: '',
    startTimeRteFilter: '',
    startTimeLteFilter: '',
    inspectTimeRteFilter: '',
    inspectTimeLteFilter: '',
    inspectorFilter: '',
    attestationFilter: '',
    qualifiedFilter: '',
    ncrCodeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'codeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.code',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.project',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supplierFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.supplier',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'contractCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.contractCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine1Filter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.projectMachine1',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'batchCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.batchCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectObjectFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.inspectObject',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByNameFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.createdByName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.orderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'faufCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.faufCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'blueprintCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.blueprintCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'groupCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.groupCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.material',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTimeRteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.startTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTimeLteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.startTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTimeRteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.inspectTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTimeLteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.inspectTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectorFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.inspector',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attestationFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.attestation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qualifiedFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.qualified',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncrCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.ncrCode',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    }
];
const incomingFilterConfigs = [
    {
        key: 'codeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.code',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.project',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supplierFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.supplier',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'contractCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.contractCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine1Filter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.projectMachine1',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'batchCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.batchCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByNameFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.createdByName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'faufCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.faufCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'blueprintCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.blueprintCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'groupCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.groupCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.material',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTimeRteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.startTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTimeLteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.startTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTimeRteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.inspectTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTimeLteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.inspectTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectorFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.inspector',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attestationFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.attestation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qualifiedFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.qualified',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncrCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.ncrCode',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    }
];
const processFilterConfigs = [
    {
        key: 'codeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.code',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.project',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'contractCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.contractCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectMachine1Filter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.projectMachine1',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByNameFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.createdByName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.orderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'faufCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.faufCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'blueprintCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.blueprintCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'groupCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.groupCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.material',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTimeRteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.startTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTimeLteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.startTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTimeRteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.inspectTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTimeLteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.inspectTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectorFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.inspector',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attestationFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.attestation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qualifiedFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.qualified',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncrCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTask.filter.ncrCode',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    }
];
const sithMesQualityInspectTaskEndFilterConfigs = [
    {
        key: 'codeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.code',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.project',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'supplierFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.supplier',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'contractCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.contractCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectObjectFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.inspectObject',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByNameFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.createdByName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryNoFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.deliveryNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectionStationFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.inspectionStation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'faufCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.faufCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'blueprintCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.blueprintCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'groupCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.groupCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.material',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTimeRteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.startTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTimeLteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.startTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTimeRteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.inspectTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTimeLteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.inspectTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectorFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.inspector',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attestationFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.attestation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qualifiedFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.qualified',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncrCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskEnd.filter.ncrCode',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    }
];
const sithMesQualityInspectTaskIncomingFilterConfigs = [
    {
        key: 'codeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.code',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poNumberFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.poNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.itemCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByNameFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.createdByName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packingMaterialFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.packingMaterial',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.project',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'faufCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.faufCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'blueprintCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.blueprintCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'groupCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.groupCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.material',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTimeRteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.startTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTimeLteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.startTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTimeRteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.inspectTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTimeLteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.inspectTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectorFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.inspector',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attestationFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.attestation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qualifiedFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.qualified',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncrCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.ncrCode',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sdrCreatorFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskIncoming.filter.sdrCreator',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    }
];
const sithMesQualityInspectTaskReturnStockFilterConfigs = [
    {
        key: 'codeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.code',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.orderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescriptionFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.materialDescription',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialLocationFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.materialLocation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.project',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByNameFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.createdByName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'faufCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.faufCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'blueprintCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.blueprintCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'groupCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.groupCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.material',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTimeRteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.startTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTimeLteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.startTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTimeRteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.inspectTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTimeLteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.inspectTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectorFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.inspector',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attestationFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.attestation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qualifiedFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.qualified',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncrCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskReturnStock.filter.ncrCode',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    }
];
const sithMesQualityInspectTaskOutsourceFilterConfigs = [
    {
        key: 'codeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.filter.code',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.filter.project',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByNameFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.filter.createdByName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'faufCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.filter.faufCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'blueprintCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.filter.blueprintCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'groupCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.filter.groupCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.filter.material',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTimeRteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.filter.startTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTimeLteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.filter.startTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTimeRteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.filter.inspectTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTimeLteFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.filter.inspectTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectorFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.filter.inspector',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attestationFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.filter.attestation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qualifiedFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.filter.qualified',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncrCodeFilter',
        label: 'label.sith.quality.sithMesQualityInspectTaskOutsource.filter.ncrCode',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'code',
        label: 'label.sith.quality.sithMesQualityInspectTask.entity.code',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTypeId',
        label: 'label.sith.quality.sithMesQualityInspectTask.entity.inspectTypeId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'project',
        label: 'label.sith.quality.sithMesQualityInspectTask.entity.project',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectObject',
        label: 'label.sith.quality.sithMesQualityInspectTask.entity.inspectObject',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'faufCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.entity.faufCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'blueprintCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.entity.blueprintCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'groupCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.entity.groupCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'material',
        label: 'label.sith.quality.sithMesQualityInspectTask.entity.material',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'startTime',
        label: 'label.sith.quality.sithMesQualityInspectTask.entity.startTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspectTime',
        label: 'label.sith.quality.sithMesQualityInspectTask.entity.inspectTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'inspector',
        label: 'label.sith.quality.sithMesQualityInspectTask.entity.inspector',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attestation',
        label: 'label.sith.quality.sithMesQualityInspectTask.entity.attestation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'qualified',
        label: 'label.sith.quality.sithMesQualityInspectTask.entity.qualified',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ncrCode',
        label: 'label.sith.quality.sithMesQualityInspectTask.entity.ncrCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityInspectTask.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'taskAttachmentList',
        label: 'label.sith.quality.sithMesQualityInspectTask.entity.taskAttachment',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'taskAttachment'
        }
    }
]

export {
    SithMesQualityInspectTask,
    newEntity,
    gridFields,
    fields,
    filterFields,
    filter,
    entityFormConfigs
    ,
    filterConfigs,
    incomingFilterConfigs,
    processFilterConfigs,
    sithMesQualityInspectTaskEndFilterConfigs,
    sithMesQualityInspectTaskIncomingFilterConfigs,
    sithMesQualityInspectTaskReturnStockFilterConfigs,
    sithMesQualityInspectTaskOutsourceFilterConfigs

    ,
    incomingVoConfigs,
    processVoConfigs,
    sithMesQualityInspectTaskEndVoConfigs,
    sithMesQualityInspectTaskIncomingVoConfigs,
    sithMesQualityInspectTaskReturnStockVoConfigs,
    sithMesQualityInspectTaskOutsourceVoConfigs
}
